import config from '../config'

export const getDownloadLink = (token, file) => {
    return `${config.endpoints.API_URL}/Descargar?token=${token}&file=${file}`
}
